export const PAID_DEPOSIT_APPROVAL_TOOLTIPS = {
  enabled: 'Approve Sales Order from paid deposit.',
  missingDeposit: 'A paid deposit invoice is required before this Sales Order can be approved.',
  alreadyApproved: 'This Sales Order is already Client Approved.',
  unauthorized: 'You do not have permission to approve this Sales Order from a paid deposit.',
  missing_invoice: 'No deposit invoice is linked to this Sales Order.',
  not_paid: 'The linked deposit invoice has not been fully paid.',
  not_deposit: 'The linked invoice is not classified as a deposit.',
  order_mismatch: 'The deposit invoice belongs to another project.',
  sales_order_mismatch: 'The deposit invoice belongs to another Sales Order.',
  instance_mismatch: 'The deposit invoice belongs to another company instance.',
};

const ELIGIBLE_STATUSES = new Set(['1', '1_sent', '2', '2_sent']);

export const getPaidDepositApprovalIconState = ({
  status,
  paidDepositApproval,
  hasPermission,
  loading = false,
} = {}) => {
  const normalizedStatus = String(status ?? '').trim().toLowerCase();
  const alreadyApproved = normalizedStatus === '3';
  const eligibleStatus = ELIGIBLE_STATUSES.has(normalizedStatus);
  const enabled = Boolean(
    hasPermission &&
    !loading &&
    !alreadyApproved &&
    eligibleStatus &&
    paidDepositApproval?.eligible
  );

  const tooltip = alreadyApproved
    ? PAID_DEPOSIT_APPROVAL_TOOLTIPS.alreadyApproved
    : !hasPermission
      ? PAID_DEPOSIT_APPROVAL_TOOLTIPS.unauthorized
      : enabled
        ? PAID_DEPOSIT_APPROVAL_TOOLTIPS.enabled
        : PAID_DEPOSIT_APPROVAL_TOOLTIPS[paidDepositApproval?.reason]
          || PAID_DEPOSIT_APPROVAL_TOOLTIPS.missingDeposit;

  return { enabled, tooltip, alreadyApproved, eligibleStatus };
};
